import { createGlobalStyle } from "styled-components";
import variables from "./variables";
export const GlobalStyle = createGlobalStyle`
    html,body,#root{
        width:100%;
        height:100%;
    }
    body{
        background-color:${variables.colors.background};
        color: ${variables.colors.font};
        font-family: 'Zen Kaku Gothic New', sans-serif;
    }
    :dir(rtl){
        font-family: Vazir, sans-serif;
    }
    .persian{
        line-height: 28px;
        font-size: 18px;
        font-family: Vazir;
    }
    *{
        outline:none;
        box-sizing: border-box;
    }
    a{
        text-decoration:none;
        color: ${variables.colors.link};
        transition: 0.2s all;
        &:hover{
            color: ${variables.colors.linkHover};
        } 
    }
    figure{
        padding: 0;
        margin: 0;
    }
    .container{
        max-width: 1360px;
        min-width: 380px;
        margin: auto;
        width: 100%;
        padding:0 16px;
    }
`;
